<template>
  <v-card flat
          tile>
    <v-toolbar color="secondary"
               dark
               flat>
      <template v-slot:extension>
        <v-row>
          <v-col>
            <v-text-field clearable
                          flat
                          hide-details
                          prepend-icon="mdi-magnify"
                          solo
                          v-bind:label="$t('search')"
                          v-model="search" />
          </v-col>
        </v-row>
      </template>
      <v-toolbar-title>{{ $t('learningTenants') }}</v-toolbar-title>
    </v-toolbar>
    <v-data-table v-bind:footer-props="{ itemsPerPageOptions: [ 5, 10, 30, 50, 100, -1 ] }"
                  v-bind:headers="headers"
                  v-bind:items="filteredLearningTenants"
                  v-bind:items-per-page="50"
                  v-bind:loading="loading"
                  v-bind:options="{ sortBy: [ 'title' ] }"
                  v-on:click:row="goToItem">
    </v-data-table>
  </v-card>
</template>

<script>
  export default {
    computed: {
      filteredLearningTenants() {
        let filteredLearningTenants = this.learningTenants

        if (this.search != null && this.search.length !== 0) {
          filteredLearningTenants = filteredLearningTenants.filter(f => f.title.toLowerCase().includes(this.search.toLowerCase()))
        }

        return filteredLearningTenants
      },
      headers() {
        return [
          {
            text: this.$t('number'),
            value: 'id'
          },
          {
            text: this.$t('title'),
            value: 'title'
          }
        ]
      }
    },
    data: () => ({
      search: null
    }),
    methods: {
      goToItem(item) {
        this.$router.push({ name: this.itemRouteName, params: { id: item.id }})
      }
    },
    name: 'LearningTenantTableCard',
    props: {
      itemRouteName: String,
      loading: Boolean,
      learningTenants: Array,
    }
  }
</script>

<i18n>
  {
    "de": {
      "number": "Nummer",
      "search": "Suche",
      "learningTenants": "Mandanten",
      "title": "Bezeichnung",
      "sort": "Sortierung"
    },
    "en": {
      "number": "Number",
      "search": "Search",
      "learningTenants": "Tenants",
      "title": "Title",
      "sort": "Sort"
    }
  }
</i18n>